export const FunnelForwardArrowHeadIcon = (props: React.ComponentProps<'svg'>) => (
  <svg width="45" height="18" viewBox="0 0 45 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0H45L21.75 18L0 0Z" />
  </svg>
);
